<template>
	<div class="tutorial">
		<Game v-if="active" />
		<SVGMask :masks="masks" :padding="10" v-if="hasMask" />
		<Button class="skip" :action="skip">Skip Tutorial</Button>
		<Bunny
			ref="bunny"
			class="hint"
			:content="step.content"
			:buttons="[{ text: step.next_button_text, action: next }]"
			:position="step.position"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Game from "@/components/views/Game";
import Button from "@/components/base/Button";
import SVGMask from "@/components/base/SVGMask";
import Bunny from '@/components/partials/Bunny';

export default {
	name: 'Tutorial',
	components: {
		Game,
		Button,
		SVGMask,
		Bunny,
	},
	computed: {
		...mapGetters("tutorial/steps", {
			step: "active",
		}),
		...mapState("tutorial", {
			active: (state) => state.active,
		}),
		mask() {
			return this.$anchors.get(this.step.selector);
		},
		masks() {
			const maskArray = !Array.isArray(this.mask) ? [this.mask] : this.mask;
			const masks = maskArray.map((anchor) => this.buildMask(anchor));
			const loaded = maskArray.some((mask) => mask.loaded);

			return loaded && this.step.overlay_coverage === "selector" ? masks : [];
		},
		hasMask() {
			return this.masks && this.step.overlay_coverage !== "none";
		},
	},
	methods: {
		buildMask(anchor) {
			const settings = "meta" in anchor && "mask" in anchor.meta ? { ...anchor.meta.mask } : {};
			const { id, element, selector } = anchor;

			return { id, element, selector, settings };
		},
		skip() {
			this.$store.dispatch("global/analytics/trackEvent", { ec: "In Game", ea: "Skip Tutorial", el: "Click" });
			this.$router.push("/tutorial/complete");
			this.$store.dispatch("sound/fx/play", { id: "button_affirmative" });
		},
		next() {
			this.$refs.bunny.pushState("exiting", () => this.$router.push("/tutorial/step/complete"));
		},
	},
	async beforeRouteUpdate(to, from, next) {
		if (to.params.index) {
			await this.$store.dispatch("tutorial/steps/activate", { index: parseInt(to.params.index) });
		}
		next();
	},
};
</script>

<style lang="scss" scoped>
	.skip {
		position: fixed !important;
		top: 15px;
		right: 15px;
		z-index: $z-top;
		transition: all $ui-transition-duration;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/Tutorial.vue